import React, { Component } from 'react';

import { Field } from '@atlaskit/form';
import { CreatableSelect } from '@atlaskit/select';

import { csvDelimiters as defaultOptions } from '@qality/common-config';

type Props = {
  input: any;
  meta: any;
  label: string;
  isRequired: boolean;
  name: string;
  isClearable: boolean;
};

type State = {
  options: Array<any>;
};

export default class CreatableSelectView extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const options = this.findOptions(props);

    this.state = {
      options,
    };
  }

  findOptions = (props: Props) => {
    const found = defaultOptions.find(
      (option) => option.value === props.input.value.value
    );
    if (!found) {
      return [...defaultOptions, props.input.value];
    } else {
      return defaultOptions;
    }
  };

  createOption = (inputValue: any) => {
    return {
      label: inputValue,
      value: inputValue,
    };
  };

  handleCreate = (inputValue: any) => {
    const { options } = this.state;
    const newOption = this.createOption(inputValue);
    this.props.input.onChange(newOption);
    this.setState({
      options: [...options, newOption],
    });
  };

  render() {
    return (
      <Field
        label={this.props.label}
        isRequired={this.props.isRequired}
        name={this.props.input.name}
      >
        {() => (
          <CreatableSelect
            classNamePrefix='list'
            isClearable={this.props.isClearable}
            onCreateOption={this.handleCreate}
            options={this.state.options}
            value={this.props.input.value}
            validationState={this.props.meta.touched && this.props.meta.error}
            onChange={this.props.input.onChange}
          />
        )}
      </Field>
    );
  }
}
